// extracted by mini-css-extract-plugin
export default {"root":"RecoverPasswordView_root__QtyTR","formWrapper":"RecoverPasswordView_formWrapper__4ikmX","subTitle":"RecoverPasswordView_subTitle__e8Hut"};